<template>
  <multiselect
    placeholder="Type to search"
    style="min-width: 150px"
    selectLabel
    v-model="selected"
    @select="update"
    @remove="clear"
    :searchable="true"
    :options="options"
    :label="labelKey"
    :trackBy="trackByKey"
    :allowEmpty="true"
    :showLabels="false"
  >
    <span slot="noResult">No results.</span>
    <template slot="placeholder">
      <span class="text-secondary"> {{ placeholder }} </span>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'GenericSingleSelect',
  components: {
    Multiselect
  },
  props: {
    placeholder: {
      type: String,
      default: 'Select option'
    },
    init: {
      type: [Object, String, Number],
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    labelKey: {
      type: String,
      default: null
    },
    trackByKey: {
      type: String,
      default: null
    },
    emitKey: {
      type: String,
      default: null
    }
  },
  data: () => ({
    selected: null
  }),
  mounted() {
    if (this.init) {
      this.selected = this.init
    }
  },
  methods: {
    reset() {
      this.selected = null
    },
    clear() {
      this.selected = null
      this.$emit('update', null)
    },
    update(option) {
      this.$emit('update', this.getEmitValue(option))
    },
    getEmitValue(selectedItem) {
      if (!this.emitKey || !selectedItem) {
        return selectedItem
      }
      return selectedItem[this.emitKey]
    }
  }
}
</script>
